// no colors in the TH palette will fulfill a11y contrast requirements
export const unselectedColor = '#6B6B6B';
